var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPathEllipsis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M13.978,16.624c0,-0.344 -0.28,-0.624 -0.624,-0.624l-4.752,0c-0.345,0 -0.624,0.28 -0.624,0.624l0,14.752c0,0.344 0.279,0.624 0.624,0.624l4.752,0c0.344,0 0.624,-0.28 0.624,-0.624l0,-14.752Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M26.987,16.593c0,-0.327 -0.266,-0.593 -0.594,-0.593l-4.813,0c-0.327,0 -0.593,0.266 -0.593,0.593l0,14.814c0,0.327 0.266,0.593 0.593,0.593l4.813,0c0.328,0 0.594,-0.266 0.594,-0.593l0,-14.814Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M39.962,16.619c0,-0.342 -0.277,-0.619 -0.619,-0.619l-4.762,0c-0.342,0 -0.619,0.277 -0.619,0.619l0,14.762c0,0.342 0.277,0.619 0.619,0.619l4.762,0c0.342,0 0.619,-0.277 0.619,-0.619l0,-14.762Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathEllipsis);
export default __webpack_public_path__ + "static/media/path-ellipsis.e8d5d040dca7d887f190caf4b221d3d5.svg";
export { ForwardRef as ReactComponent };